export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 50
    },
    {
      prop: 'username',
      label: '业务员',
      minWidth: 50,
    },
    {
      prop: 'phone',
      label: '手机号',
      minWidth: 50,
    },
    {
      prop: 'is_enabled',
      label: '状态',
      minWidth: 50,
    },
    {
      prop: 'status',
      label: '审核状态',
      minWidth: 50,
    },
    {
      prop: 'create_time',
      label: '创建时间',
      minWidth: 50,
    },
    {
      prop: "handle",
      label: "操作",
      minWidth: 50,
    },
  ]
}


export default {}